module.exports = {"company":"H.C. Wainwright","name":"Media Room Admin","auth":{"endpoint":"/auth/admin","method":"post"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/application.json
// module id = 93
// module chunks = 0